module.exports = __webpack_public_path__ + "img/hand-clap.6b7808af.gif";